import { ScreenUtil } from '../../util/screen-util.js'
import { LogicBlock } from './logic-block.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Block } from '../block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { BoVisitor } from '../../bos/bo-visitor.js'
import { EditorPropertiesManager } from '../decorators/editor-properties-manager.js'
import { Expression } from '../../data/text-or-code.js'

@jsonClass('IfBlock')
export class IfBlock extends LogicBlock {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Condition',
		codeLanguage: 'ts',
		tsReturnType: () => 'any',
		editorSize: 'normal',
		isBinding: false,
		isMandatory: () => true,
		spanColumns: '1 / -1',
	})
	conditionCode = new Expression('false')

	constructor(init: Partial<IfBlock> = {}) {
		super()
		this.init(init)
	}

	getChildrenToCompile(): Block[] {
		if (this.conditionCode.content?.trim() == 'false') return []
		return super.getChildrenToCompile()
	}

	getEditorTitle() {
		return `${super.getEditorTitle()} ${this.conditionCode.content}`
	}

	visitThisWithBoVisitor(
		visitor: BoVisitor,
		pathPrefix: (string | number)[],
	): void {
		// visitor.visitTsCode(this.conditionCode, EditorPropertiesManager.getPropertyByKey(IfBlock.prototype, 'conditionCode'), 'property', [...pathPrefix, 'conditionCode'], newCode => this.conditionCode = newCode)
		this.visitCodePropertyWithBoVisitor(
			visitor,
			pathPrefix,
			IfBlock,
			'conditionCode',
		)
	}

	getEditorCategory(): string {
		return 'Logic'
	}
}
